import { Create, TextInput, required, SimpleForm, DateInput, SelectInput, ReferenceInput, AutocompleteInput } from 'react-admin';
import { Batches, Programs } from '../../custom';
import { validateNotEmpty } from '../../common/VideoPlayer/util';


export const ProgramRender = (choice: Programs) => `${choice.name}`;
export const BatchesRender = (choice: Batches) => `${choice.title
    }`;

const DemoVideosCategoriesCreate = () => {

    return <>
        <Create redirect={'/demo-video-categories'}>
            <SimpleForm>
                <TextInput source="name" fullWidth validate={[required(), validateNotEmpty]} />
                <ReferenceInput name={'Programs'} source={'programId'} reference={'programs'}
                    fullwidth>
                    <AutocompleteInput optionText={ProgramRender}
                        debounce={500} fullWidth />
                </ReferenceInput>
                <ReferenceInput name={'batches'} source={'batchId'} reference={'batches'}
                    fullwidth>
                    <AutocompleteInput optionText={BatchesRender}
                        debounce={500} fullWidth />
                </ReferenceInput>
            </SimpleForm>
        </Create>
    </>

};

export default DemoVideosCategoriesCreate;
